import React, { useEffect, useMemo, useState } from "react";
import "./styles.css";
import { ReactTable } from "../../Components/Molecules";
import { Breadcrumb, HeaderWallet, Switcher, Title } from "../../Components/Atoms";
import { TRANSACTION_TABLE_HEADERS } from "../../Library/tableHeaders";
import PATHS from "../../Routes/paths";
import { getAllTransactions, getTransactions } from "../../APIs";
import { getLocalisedNumber } from "../../Library/helpers";
import { Link, useNavigate } from "react-router-dom";


const breadcrumbPaths = [
  { idx: 1, name: "Wallet", link: PATHS.DEALERS_OVERVIEW },
  { idx: 1, name: "Transactions", link: "", isCurrentPage: true },
];

const TransactionTable = () => {
  const [transactions, setTransactions] = useState([]);
  const [selectedPage, setSelectedPage] = useState(2);

  const navigate = useNavigate();

  useEffect(() => {
    getAllTransactions((err, data) => {
      if (err) {
        console.error("Error while fetching transactions", err);
        return;
      }

      setTransactions(data.sort((a, b) => b.ts - a.ts));
    });
  }, []);
  const columns = useMemo(
    () =>
      Object.values(TRANSACTION_TABLE_HEADERS).map((header) => {
        return {
          Header: header.nm,
          accessor: header.key,
          disableSortBy: !header.sorting,
          Cell: (row) => {
            if (row.column.id === "ts") {
              const date = new Date(row.value);
              return <span className="dc">{`${date.getDate()} ${date.toLocaleString("default", {
                month: "long",
              })} ${date.getFullYear()}`}</span>
            }
            if (row.column.id === "remQty") {
              const balance = Math.abs(row.value);
              return row.value  < 0
                ? <span className="dc">{`- ${getLocalisedNumber(balance || 0)}`}</span>
                : <span className="dc">{`${getLocalisedNumber(balance || 0)}`}</span>
            }
            if (row.column.id === "qty") {
              if (row.cell.row.original.actTyp === 2) {
                return (
                  <span className="credit dc">
                    -{Math.abs(row.value)}
                  </span>
                );
              }
              return (
                <span className="debit dc">+{getLocalisedNumber(row.value)}</span>
              );
            }
            if (row.column.id === "actTyp") {
              if (row.cell.row.original.refId) {
                let link = `${row.value === 1 ? "" : PATHS.SHIPMENT_OVERVIEW}${PATHS.ORDERS_OVERVIEW}/${PATHS.ORDER_DETAIL}?`;
                if (row.value === 1) link += `idx=${row.cell.row.original.refId}`;
                else link += `shipId=${row.cell.row.original.refId}`;

                return (
                  <Link to={link}>
                    <span className="dc order-id">
                      {row.value === 1 ? "Device Order" : "Shipment"} -{" "}
                      <span>
                        {row.cell.row.original.refId}
                      </span>
                    </span>
                  </Link>
                );
              }
              return <span className="dc">{row.value}</span>;
            }
            return <span className="dc">{row.value || "-"}</span>;
          },
        };
      }),
    []
  );

  const PAGE_SWITCHER_OPTIONS = [
    { idx: 1, label: "All Orders", path: PATHS.ORDERS_OVERVIEW },
    { idx: 2, label: "History", path: `${PATHS.ORDERS_OVERVIEW}/${PATHS.TRANSACTION_DETAILS}` },
  ]

  const handlePageSwitch = (tab) => {
    setSelectedPage(tab.idx);
    navigate(tab.path);
  }

  return (
    <div className="transaction-table">
      <header className="transactions-header">
        <HeaderWallet />
        <div className="place-new-order-btn-hidden"></div>
      </header>
      <Switcher
        className="orders-page-switcher transactions"
        options={PAGE_SWITCHER_OPTIONS}
        selectedOption={selectedPage}
        handleChange={handlePageSwitch}
      />

      <div className="table-wrapper">
        <div className="header">
          <Title variant="lg" fixed>
            Device Stock History
          </Title>
        </div>
        <div className="table-container">
          <ReactTable
            columns={columns}
            data={transactions}
            showSearch={false}
            pageSize={10}
          />
        </div>
      </div>
    </div>
  );
};

export default TransactionTable;
